import { AddWorkAreaModalPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

export const useMapWorkAreasFlag = () => {
  const { company } = useCurrentSession()
  const { data } = useQuery(AddWorkAreaModalPageDocument, {
    variables: { companyId: company.id },
  })

  return (
    data?.features.featuresConnection.nodes.find(
      (featureFlag) => featureFlag.name === 'dev_space_control_map_work_areas'
    )?.enabled || false
  )
}
